"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _qm = _interopRequireWildcard(require("@/api/qm"));
var qm = _qm;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'XXOrderDetail',
  props: {
    xxOrderInfo: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      loading: false,
      direction: 'rtl',
      dialogVisible: false,
      orderData: {},
      srcList: []
    };
  },
  watch: {},
  mounted: function mounted() {},
  methods: {
    getDetail: function getDetail(data) {
      var _this = this;
      console.log(data);
      qm.qmCarOrderTestDetailApi({
        cancel_time: data.service_date,
        bname: data.service_store,
        car_num: data.license_plate
      }).then(function (res) {
        _this.orderData = res;
        _this.srcList.push(res.report_image);
        console.log(_this.srcList);
      });
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    }
  }
};